import React from 'react';
import Logout from './Logout';
import { Link } from 'react-router-dom';
import '../gral-stylesheets/dropdown.scss';



class Dropdown extends React.Component {

  render() {
    let dropdownType = this.props.type;
    let navbarElementClicked = this.props.navbarElementClicked;
    let dropdownList = this.props.options.map((option, index) => (
      dropdownType === 'selector' ?
        <li
          key={index}
          className='list'
        >
          <div
            className='selector-item'
            data-value={option.title}
            onClick={this.props.languageHandle}
          >
            <h4>{option.language}</h4>
          </div>
        </li>
        :
        dropdownType === 'notification' ?
          <li
            key={index}
            className='list'
          >
            <div className='notification-item'>
              <h4>{option.notification}</h4>
            </div>
          </li>
          :
          option.item === 'Logout' ?
            <li
              key={index}
              className='list'
            >
              <Logout
                icon={option.icon}
              />
            </li>
            :
            <li
              key={index}
              className='list' 
            >
              <Link to='/account'>
                <div
                  className={
                    navbarElementClicked === option.dataValue 
                      ? 'user-item on'
                      : 'user-item'}
                  data-value={option.dataValue}
                  onClick={this.props.dropdownOffHandle}
                >
                  <i>{option.icon}</i>
                  <h4>{option.item}</h4>
                </div>
              </Link>
            </li>
    ));
    return (
      <div
        className='dropdown-visible'
        onMouseEnter={this.props.dropDownOn}
        onMouseLeave={this.props.dropDownOff}
      >
        <ul className='dropdown-list'>
          <li className='dropdown-list-title'>
            <h3>
              {this.props.activeTitle}
            </h3>
          </li>
          {dropdownList}
        </ul>
      </div>
    )
  }
}

export default Dropdown;